import { gql } from "@apollo/client";

export const CODART_FRAGMENT = gql`
  fragment CodartPart on Codart {
    id
    code
    name
    hiddenLink
    publicLink
  }
`;

export const CODART = gql`
  query CodartQuery($code: String!) {
    codart(code: $code) {
      ok
      error
      result {
        ...CodartPart
      }
    }
  }
  ${CODART_FRAGMENT}
`;
